import Color from 'color';
import { ManifestComponentExtensionType } from '../ManifestStore';
import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import { isColorStyleProperty, isNumberStyleProperty, mapStyleParamToTpaStyleParam } from '../utils/OOIStyles';
export class ExternalStylesHandler extends AbstractExternalAPIHandler {
  constructor(dm, hostAPI, manifestStore, manifestDefaultValues) {
    super(dm, hostAPI, manifestStore);
    this.dm = dm;
    this.hostAPI = hostAPI;
    this.manifestStore = manifestStore;
    this.manifestDefaultValues = manifestDefaultValues;
  }
  getStyles(editorPointer, type) {
    switch (type) {
      case ManifestComponentExtensionType.BLOCKS:
      case ManifestComponentExtensionType.BUILDER:
        {
          const contextualEditorPointer = this.hostAPI.stage.getPointerWithCurrentVariants(editorPointer);
          return this.hostAPI.components.cssStyle.get(contextualEditorPointer);
        }
      case ManifestComponentExtensionType.OOI:
        {
          const manifest = this.manifestStore.getManifestByEditorPointer(editorPointer);
          const cssCustomProperties = manifest == null ? void 0 : manifest.cssCustomProperties;
          const returnObject = {};
          if (!cssCustomProperties) {
            return Promise.resolve(returnObject);
          }
          const dmStyles = this.dm.tpa.style.getByComp(editorPointer.documentPointer);
          const siteColors = dmStyles.siteColors;
          const styleValues = dmStyles.style;
          const resolveDefaultStyleValue = value => {
            if (typeof value === 'boolean' || typeof value === 'number') {
              return value;
            }
            if (typeof value === 'object' && value.preset) {
              var _siteColors$find;
              const hexValue = (_siteColors$find = siteColors.find(siteColor => siteColor.name === value.preset)) == null ? void 0 : _siteColors$find.value;
              const opacity = value.opacity;
              if (!hexValue) {
                return undefined;
              }
              if (opacity) {
                return Color(hexValue).alpha(opacity).hexa();
              }
              return hexValue;
            }
            return undefined;
          };
          Object.entries(cssCustomProperties).forEach(_ref => {
            let [key, value] = _ref;
            const defaultStyle = this.manifestDefaultValues.getDefaultStyleValueByEditorPointer(editorPointer, key);
            const defaultStyleValue = resolveDefaultStyleValue(defaultStyle);
            const existsInDmColorStyles = () => Object.keys(styleValues.colors).find(colorKey => colorKey === key);
            const existsInDmNumberStyles = () => Object.keys(styleValues.numbers).find(numberKey => numberKey === key);
            if (isColorStyleProperty(value.cssPropertyType) && existsInDmColorStyles()) {
              returnObject[key] = styleValues.colors[key].value;
            } else if (isNumberStyleProperty(value.cssPropertyType) && existsInDmNumberStyles()) {
              returnObject[key] = `${styleValues.numbers[key].toString()}px`;
            } else if (defaultStyleValue) {
              returnObject[key] = defaultStyleValue.toString();
            }
          });
          return Promise.resolve({
            cssCustomProperties: returnObject,
            cssProperties: {}
          });
        }
      default:
        throw new Error('not implemented');
    }
  }
  async setStyles(editorPointer, type, styles) {
    switch (type) {
      case ManifestComponentExtensionType.BLOCKS:
      case ManifestComponentExtensionType.BUILDER:
        {
          const _styles = Object.entries(styles).reduce((acc, _ref2) => {
            var _Object$keys;
            let [key, value] = _ref2;
            return value && ((_Object$keys = Object.keys(value)) == null ? void 0 : _Object$keys.length) > 0 ? {
              ...acc,
              [key]: value
            } : acc;
          }, {});
          const contextualEditorPointer = this.hostAPI.stage.getPointerWithCurrentVariants(editorPointer);
          return this.hostAPI.components.cssStyle.update(contextualEditorPointer, _styles);
        }
      case ManifestComponentExtensionType.OOI:
        {
          const compRef = editorPointer.documentPointer;
          const manifest = this.manifestStore.getManifestByEditorPointer(editorPointer);
          const manifestCustomProperties = (manifest == null ? void 0 : manifest.cssCustomProperties) ?? {};
          const newCustomProperties = styles.cssCustomProperties ?? {};
          const siteColors = this.dm.tpa.style.getByComp(editorPointer.documentPointer).siteColors;
          const tpaStyleParams = Object.entries(newCustomProperties).map(_ref3 => {
            let [key, value] = _ref3;
            const styleParam = manifestCustomProperties[key];
            const cssPropertyType = styleParam == null ? void 0 : styleParam.cssPropertyType;
            return cssPropertyType ? mapStyleParamToTpaStyleParam({
              key,
              value,
              siteColors,
              type: cssPropertyType
            }) : undefined;
          }).filter(obj => !!obj);
          if (tpaStyleParams.length) {
            await this.dm.tpa.style.setCompStyleParam(compRef, tpaStyleParams, () => {});
          }
          break;
        }
      default:
        throw new Error('not implemented');
    }
    return Promise.resolve();
  }
  async removeStyles(editorPointer, type, styles) {
    switch (type) {
      case ManifestComponentExtensionType.BLOCKS:
      case ManifestComponentExtensionType.BUILDER:
        {
          const ROOT_KEY_MAP = {
            cssPropertiesKeys: 'cssProperties',
            cssCustomPropertiesKeys: 'cssCustomProperties'
          };
          const _styles = Object.entries(styles).reduce((acc, _ref4) => {
            let [key, values] = _ref4;
            const path = ROOT_KEY_MAP[key];
            if (!path) {
              return acc;
            }
            if (values != null && values.length) {
              return [...acc, ...values.map(v => `${path}.${v}`)];
            }
            return acc;
          }, []);
          const contextualEditorPointer = this.hostAPI.stage.getPointerWithCurrentVariants(editorPointer);
          return this.hostAPI.components.cssStyle.remove(contextualEditorPointer, _styles);
        }
      default:
        throw new Error('not implemented');
    }
  }
  getDefaultCssPropertyValue(editorPointer, type, dataItemId) {
    return this.manifestDefaultValues.getDefaultCssPropertyValueByEditorPointer(editorPointer, dataItemId);
  }
  getDefaultCustomCssPropertyValue(editorPointer, _type, dataItemId) {
    return this.manifestDefaultValues.getDefaultCustomCssPropertyValueByEditorPointer(editorPointer, dataItemId);
  }
}
//# sourceMappingURL=ExternalStylesHandler.js.map